import { bl_fi_gendoc_to_sales_contract_templates_link_RowClass } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";

export class SalesContractTemplateGenDocLinkContainerModel extends BaseContainerModel {
  bl_fi_gendoc_to_sales_contract_templates_link: bl_fi_gendoc_to_sales_contract_templates_link_RowClass =
    new bl_fi_gendoc_to_sales_contract_templates_link_RowClass();
}
